import { RESOLVABLE_TREE_PRIVATE } from './privates';
import { ConstructResolvableTree } from './constructor';
export function ResolvableTreeGetChildren(instance) {
    return instance[RESOLVABLE_TREE_PRIVATE].children;
}
export function ResolvableTreeResolve(instance, options) {
    return instance[RESOLVABLE_TREE_PRIVATE].resolve.call(instance, options);
}
export class ResolvableTree {
    constructor(options) {
        ConstructResolvableTree(this, options);
    }
    get children() {
        return ResolvableTreeGetChildren(this);
    }
    resolve(options) {
        return ResolvableTreeResolve(this, options);
    }
}
//# sourceMappingURL=implementation.js.map